function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "arrow-rotate-right");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Version_2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-rotate-right",
  transform: "translate(0.500000, 0.500000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.4953122,0.00515556335 C14.2204685,0.00515556335 17.6109381,1.96265602 19.5,5.13328171 L19.5,0.75 C19.5,0.335625172 19.8375006,0 20.25,0 C20.6624994,0 21,0.335625172 21,0.75 L21,6.75 C21,7.16249943 20.6624994,7.5 20.25,7.5 L14.25,7.5 C13.8375006,7.5 13.5,7.16249943 13.5,6.75 C13.5,6.33750057 13.8375006,6 14.25,6 L18.274219,6 C16.6640625,3.22031307 13.7296872,1.5 10.5,1.5 C5.53593779,1.5 1.5,5.53593779 1.5,10.5 C1.5,15.4640622 5.53734398,19.5 10.5,19.5 C13.2881255,19.5 15.8765631,18.2385936 17.5921869,16.0387502 C17.8470926,15.7106252 18.3178124,15.650578 18.6454682,15.9098439 C18.9713902,16.1647496 19.0292344,16.6364064 18.7743745,16.961719 C16.7681251,19.5281253 13.7446861,20.9953136 10.4915621,20.9953136 C4.70624971,20.9953136 0,16.2890625 0,10.5 C0,4.7109375 4.70624971,0.00515556335 10.4953122,0.00515556335 Z",
  id: "Path"
})));
const SvgIconReset = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconReset, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-reset.c3c36e3c.svg";
export { ForwardRef as ReactComponent };